import { COLORS } from "./Paymenthistoryconstants";

/**
 * Liste ekranlarının ortak kurumsal stilleri (tablo, chip, filtre çubuğu,
 * özet kartı, sağ detay paneli, sayfalama).
 *
 * Ödeme Geçmişi ekranında elle yazılmış olan bu kurallar burada tek kaynağa
 * toplandı; her ekran kendi scope sınıfını vererek aynı görünümü alır.
 *
 * @param {string} scope Sayfa kök sınıfı (nokta olmadan) — örn. "payment-links-modern"
 */
export const getModernTableStyles = (scope) => `
  /* --- Tablo --- */
  .${scope} .table thead tr { background-color: #f9f9f9; }
  .${scope} .table th { border: 0; color: #6c757d; font-weight: 600; }
  .${scope} .table td { vertical-align: middle; padding-top: .85rem; padding-bottom: .85rem; }
  .${scope} .table-hover tbody tr:hover { background: #fcfcfd; }
  .${scope} .cell-sub { color: #8a94a6; font-size: .78rem; }

  /* --- Butonlar --- */
  .${scope} .btn-rounded { border-radius: 999px; }
  .${scope} .btn-navy { background: ${COLORS.NAVY}; border-color: ${COLORS.NAVY}; color: #fff; }
  .${scope} .btn-navy:hover { filter: brightness(1.03); color: #fff; }
  .${scope} .btn-navy-outline { background: #fff; border-color: ${COLORS.NAVY}; color: ${COLORS.NAVY}; }
  .${scope} .btn-navy-outline:hover { background: #f4f7fc; color: ${COLORS.NAVY}; }
  .${scope} .btn-orange { background: ${COLORS.ORANGE}; border-color: ${COLORS.ORANGE}; color: #fff; }
  .${scope} .btn-orange:hover { filter: brightness(1.03); color: #fff; }
  .${scope} .btn-orange-outline { background: #fff; border-color: ${COLORS.ORANGE}; color: ${COLORS.ORANGE}; }
  .${scope} .action-btn { border-radius: 999px; padding: .35rem .6rem; }
  .${scope} .pill-input,
  .${scope} .pill-select { border-radius: 999px !important; padding: .45rem .9rem; }

  /* --- Rozetler (chip) --- */
  .${scope} .chip {
    display: inline-flex; align-items: center; gap: .35rem;
    padding: .3rem .7rem; border-radius: 999px;
    font-weight: 600; font-size: 12px; border: 0;
  }
  .${scope} .chip:hover { filter: brightness(1.03); }
  .${scope} .chip-navy { background: #E7EEF8; color: ${COLORS.NAVY}; }
  .${scope} .chip-navy-solid { background: ${COLORS.NAVY}; color: #fff; }
  .${scope} .chip-orange { background: #FFF1E0; color: ${COLORS.ORANGE}; }
  .${scope} .chip-orange-solid { background: ${COLORS.ORANGE}; color: #fff; }
  .${scope} .chip-green { background: #E8F6DB; color: #2E7D32; }
  .${scope} .chip-amber { background: #FFF3CD; color: #8A6D3B; }
  .${scope} .chip-red { background: #FDE2E2; color: #B42318; }
  .${scope} .chip-gray { background: #ECEFF3; color: #4B5563; }
  .${scope} .chip-purple { background: #EFE7FB; color: #6f42c1; }

  /* --- Özet kartları --- */
  .${scope} .mini-stat-card {
    display: flex; align-items: center; gap: .9rem; height: 100%;
    border: 1px solid #e9ecef; border-radius: 1rem;
    padding: 1.1rem 1.25rem; min-height: 95px; background: #fff;
    box-shadow: 0 1px 2px rgba(0,0,0,.04);
    transition: box-shadow .2s ease;
  }
  .${scope} .mini-stat-card:hover { box-shadow: 0 2px 4px rgba(0,0,0,.08); }
  .${scope} .mini-stat-amount { font-weight: 700; font-size: 1.3rem; line-height: 1.25; }
  .${scope} .mini-stat-icon {
    width: 44px; height: 44px; flex: 0 0 44px; border-radius: 50%;
    display: flex; align-items: center; justify-content: center; font-size: 1.4rem;
  }
  .${scope} .mini-stat-icon.total { background: #E7EEF8; }
  .${scope} .mini-stat-icon.total i { color: ${COLORS.NAVY}; }
  .${scope} .mini-stat-icon.success { background: #e6f6ec; }
  .${scope} .mini-stat-icon.pending { background: #fff6e6; }
  .${scope} .mini-stat-icon.failed { background: #fdecea; }
  .${scope} .mini-stat-icon.info { background: #EFE7FB; }
  .${scope} .stat-blur { filter: blur(1px); opacity: .55; }

  /* --- Filtre bloğu --- */
  .${scope} .filter-bar {
    background: #fbfcfe; border: 1px solid #eef1f5;
    border-radius: 1rem; padding: 1.15rem 1.25rem;
  }
  .${scope} .filter-field { min-width: 180px; flex: 1 1 180px; }
  .${scope} .filter-label {
    font-size: .72rem; color: #8a94a6; font-weight: 600;
    text-transform: uppercase; letter-spacing: .02em;
    margin-bottom: .3rem; display: block;
  }
  .${scope} .filter-bar .pill-input,
  .${scope} .filter-bar .pill-select { height: 40px; padding-top: .4rem; padding-bottom: .4rem; }
  .${scope} .filter-actions .btn { height: 40px; padding-inline: 1.25rem; }
  .${scope} .toolbar-actions .btn { height: 38px; padding-inline: 1rem; }

  /* --- Sayfalama --- */
  .${scope} .corporate-pagination .page-link { color: ${COLORS.NAVY}; border-color: ${COLORS.ORANGE}; }
  .${scope} .corporate-pagination .page-item.active .page-link {
    background-color: ${COLORS.NAVY}; border-color: ${COLORS.NAVY}; color: #fff;
  }
  .${scope} .corporate-pagination .page-link:hover { border-color: ${COLORS.NAVY}; color: ${COLORS.NAVY}; }
  .${scope} .page-size-wrap { display: flex; align-items: center; gap: .5rem; white-space: nowrap; }
  .${scope} .page-size-wrap .text-muted { font-size: .9rem; }
  .${scope} .page-size-select { min-width: 70px; padding-right: 1.75rem; border-radius: 999px !important; }

  /* --- Satır seçimi --- */
  .${scope} .table tbody tr.row-clickable { cursor: pointer; }
  /* Bootstrap 5 hover/stripe rengini hücrelere (tr > *) uyguladığı için arka planı
     satır yerine hücrelere veriyoruz; aksi halde hover bitince beyaza dönüyor. */
  .${scope} .table tbody tr.row-selected > * {
    background-color: #eceff3 !important; --bs-table-bg-state: #eceff3;
  }
  .${scope} .table tbody tr.row-selected:hover > * {
    background-color: #e2e7ee !important; --bs-table-bg-state: #e2e7ee;
  }
  .${scope} .table tbody tr.row-selected > *:first-child { box-shadow: inset 3px 0 0 ${COLORS.NAVY}; }

  /* --- Sağ detay paneli --- */
  /* Tema .main-content'e overflow:hidden veriyor (_vertical.scss); bu, içindeki
     position:sticky'yi devre dışı bırakıyor. Yatay kırpmayı koruyup dikeyde
     sticky'nin çalışması için yalnızca bu sayfada overflow-x:clip'e çeviriyoruz.
     Sınıf body'ye mount sırasında eklenir; daha önce kullanılan :has() tabanlı
     seçici her stil yeniden hesabında değerlendirildiği için takılmaya yol açıyordu. */
  body.${scope}-page .main-content { overflow-x: clip; overflow-y: visible; }

  /* Kolon GENİŞLİĞİNE transition verilmez: panel ilk açılışta ana kolon hâlâ
     %100'den küçülürken mount olduğundan satıra sığmayıp tablonun ALTINA
     düşüyor, animasyon bitince sağa zıplıyordu. Kolonlar anında yerine oturur;
     açılış hissi panelin kendi fade/slide animasyonuyla verilir. */
  @keyframes ${scope}-pd-in {
    from { opacity: 0; transform: translateX(14px); }
    to { opacity: 1; transform: none; }
  }

  /* Panel içeriği kadar uzar: iç kaydırma yok, her şey tek bakışta görünür.
     Bu yüzden viewport yüksekliği (100vh) ve sticky de yok — panel ekrana
     sabitlenseydi içerik viewport'tan uzun olduğunda alt kısmı hiç görünmezdi. */
  .${scope} .pd-panel {
    background: #fff; border: 0; border-radius: 1rem;
    box-shadow: 0 .5rem 1.25rem rgba(10,49,110,.08);
    height: auto;
    display: flex; flex-direction: column; overflow: visible;
    animation: ${scope}-pd-in .18s ease-out;
  }
  .${scope} .pd-panel-header {
    flex: 0 0 auto; display: flex; align-items: center; justify-content: space-between;
    padding: 1rem 1.15rem; border-bottom: 1px solid #eef1f5;
  }
  .${scope} .pd-panel-body { flex: 1 1 auto; padding: 1.15rem; overflow-y: visible; }
  .${scope} .pd-amount { font-size: 1.75rem; font-weight: 700; color: #1e293b; margin: .65rem 0 .15rem; }
  .${scope} .pd-info-list { border: 1px solid #eef1f5; border-radius: .85rem; padding: .35rem .85rem; }
  .${scope} .pd-info-row {
    display: flex; align-items: center; justify-content: space-between; gap: .75rem;
    padding: .5rem 0; border-bottom: 1px solid #f4f6f9;
  }
  .${scope} .pd-info-row:last-child { border-bottom: 0; }
  .${scope} .pd-info-label { color: #8a94a6; font-size: .82rem; white-space: nowrap; }
  .${scope} .pd-info-value { color: #1e293b; font-size: .85rem; font-weight: 600; text-align: right; }
  /* Tam detay tuşu artık aksiyon yığınının ilk elemanı: ölçüsünü .pd-actions .btn
     kuralından alır, burada yalnız rengi tanımlanır. Gri ton, altındaki lacivert
     aksiyonlardan ayrışsın diye; renk sınıf yerine burada veriliyor çünkü
     custom.css .btn-secondary'yi !important ile laciverte çeviriyor.
     Ton, chip-gray ile aynı (#ECEFF3 / #4B5563). */
  .${scope} .pd-full-link {
    background: #ECEFF3; border-color: #ECEFF3; color: #4B5563;
  }
  .${scope} .pd-full-link:hover,
  .${scope} .pd-full-link:focus {
    background: #dfe4ea; border-color: #dfe4ea; color: #4B5563;
  }
  /* Makbuz görüntüle + indir yan yana; dar panelde alt alta düşer. */
  .${scope} .pd-receipt-actions { display: flex; gap: .6rem; flex-wrap: wrap; }
  .${scope} .pd-receipt-actions .btn { flex: 1 1 150px; }
  .${scope} .pd-fail-box {
    margin-top: 1rem; padding: .75rem .9rem; border-radius: .85rem;
    background: #FDE2E2; color: #B42318;
  }
  /* Teknik satırlar (kod / sağlayıcı mesajı): kullanıcı açıklamasından ayrılsın diye
     kesikli çizgiyle ayrılır ve daha küçük punto ile basılır. */
  .${scope} .pd-fail-tech {
    margin-top: .5rem; padding-top: .5rem; border-top: 1px dashed rgba(180,35,24,.35);
    font-size: .72rem; line-height: 1.5; word-break: break-word; opacity: .9;
  }
  .${scope} .pd-summary {
    margin-top: 1rem; padding: .9rem 1.05rem;
    border: 1px solid #eef1f5; border-radius: .85rem; background: #fbfcfe;
  }
  .${scope} .pd-summary-title { font-weight: 700; color: #1e293b; font-size: .95rem; margin-bottom: .6rem; }
  .${scope} .pd-summary-row {
    display: flex; align-items: center; justify-content: space-between;
    padding: .3rem 0; font-size: .85rem; color: #8a94a6;
  }
  .${scope} .pd-summary-row span:last-child { color: #1e293b; font-weight: 600; }
  .${scope} .pd-summary-total {
    margin-top: .35rem; padding-top: .6rem; border-top: 1px solid #e6eaf0;
    color: #1e293b; font-weight: 700;
  }
  .${scope} .pd-summary-total span:last-child { font-size: .95rem; }
  .${scope} .pd-actions { display: flex; flex-direction: column; gap: .6rem; margin-top: 1.15rem; }
  .${scope} .pd-actions .btn { height: 44px; font-weight: 600; }

  /* xl altında panel sağdan açılan overlay olur */
  @media (max-width: 1199.98px) {
    .${scope} .ph-side {
      position: fixed; top: 0; right: 0; bottom: 0;
      width: min(420px, 100%); z-index: 1046; padding: 0;
    }
    /* xl altı overlay: panel ekrana sabit olduğu için burada iç kaydırma şart. */
    .${scope} .pd-panel { position: static; border-radius: 0; height: 100%; max-height: none; overflow: hidden; }
    .${scope} .pd-panel-body { overflow-y: auto; }
    .${scope} .pd-backdrop { position: fixed; inset: 0; background: rgba(15,23,42,.35); z-index: 1045; }
  }

  @media (max-width: 576px) {
    .${scope} .table { font-size: 12px; }
    .${scope} .table td, .${scope} .table th { padding: .5rem; }
    .${scope} .mini-stat-card { padding: .5rem .75rem; }
    .${scope} .mini-stat-amount { font-size: .95rem; }
    .${scope} .action-btn { padding: .25rem .4rem; font-size: .85rem; }
    .${scope} .page-size-wrap { gap: .35rem; }
    .${scope} .page-size-select { min-width: 64px; }
  }
`;

export default getModernTableStyles;
